import type { ProductAttributeGroupOfValue, ProductOfVariant, ProductOfVariantForCustomer } from "../Product.js";

export function getProductLegacyId(
	product: Pick<ProductOfVariant | ProductOfVariantForCustomer, "legacyIds" | "variant">,
	attributes: Pick<ProductAttributeGroupOfValue, "value" | "id">[] = [],
): string | undefined {
	const combination = product.legacyIds.find(
		(combination) =>
			combination.variantId === product.variant.id &&
			combination.attributes.every((attribute) =>
				attributes.some(({ id, value }) => attribute.groupId === id && attribute.valueId === value.id),
			),
	);
	return combination?.legacyId;
}
